import type { FunctionComponent } from "react"

import { Callout } from "@jobteaser/spark/components/Callout"
import { Text } from "@jobteaser/spark/components/Text"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./StatusWarning.module.css"

export type StatusWarningProps = {
  status: "incomplete" | "pending" | "waitingList"
}

export const StatusWarning: FunctionComponent<StatusWarningProps> = ({ status }) => {
  const { t } = useTranslation(["event_details"])

  return (
    <Callout variant="warning" className={styles.main} data-testid="event-details-registration-details-status-warning">
      <Text variant="body1" weight="bold" data-testid={`event-details-registration-details-status-warning-${status}`}>
        {t(`event_details.status.${status}`)}
      </Text>
      {status !== "waitingList" && <Text variant="body1">{t(`event_details.status.${status}_message`)}</Text>}
    </Callout>
  )
}
